import { render, staticRenderFns } from "./SendMailNotification.vue?vue&type=template&id=13370e7a&"
import script from "./SendMailNotification.vue?vue&type=script&lang=js&"
export * from "./SendMailNotification.vue?vue&type=script&lang=js&"
import style0 from "./SendMailNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports